<template>
    <b-card
        :header="title"
        header-text-variant="white"
        header-bg-variant="info"
        >
        <b-row class="mb-2">
            <b-col lg="4">
                <label>For Specialist</label>
                <b-form-select v-model="specialistFilter">
                    <option value="">-- none selected --</option>
                    <option v-for="admin in admins" :key="admin.id" :value="admin.id">{{ admin.nameLastFirst }}</option>
                </b-form-select>
            </b-col>
            <b-col lg="4">
                <label>Start Date</label>
                <date-picker
                        class="mb-1"
                        v-model="start_date"
                        placeholder="Start Date">
                </date-picker>
            </b-col>
            <b-col lg="4">
                <label>End Date</label>
                <date-picker
                        class="mb-1"
                        v-model="end_date"
                        placeholder="End Date">
                </date-picker>
            </b-col>
        </b-row>

        <b-row>

            <b-col>

                <b-btn variant="info" size="sm" @click=" loadItems " class="pull-right my-3">Generate</b-btn>
            </b-col>
        </b-row>

        <div class="table-responsive">
            <b-table bordered striped hover show-empty
                     :items="tableData"
                     :fields="fields"
                     :current-page="currentPage"
                     :per-page="perPage"
                     :filter="filter"
                     :sort-by.sync="sortBy"
                     :sort-desc.sync="sortDesc"
                     @filtered="onFiltered"
            >
                <template v-slot:cell(actions)="row">
                    <b-btn size="sm" :href="'/business/exceptions/' + row.item.id">Details</b-btn>
                    <b-btn variant="info" size="sm" @click="assign(row.item)">Assign</b-btn>
                </template>
            </b-table>
        </div>

        <b-row>
            <b-col lg="6" >
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
            </b-col>
            <b-col lg="6" class="text-right">
                Showing {{ perPage < totalRows ? perPage : totalRows }} of {{ totalRows }} results
            </b-col>
        </b-row>

        <b-modal id="assignModal" title="Assign To Specialist" v-model="assignModal">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <b-form-group label="Specialist" label-for="specialist_id">
                            <b-select name="specialist_id" id="specialist_id" v-model="assignForm.specialist_id">
                                <option value="">-- Select a Specialist --</option>
                                <option v-for="admin in admins" :key="admin.id" :value="admin.id">{{ admin.nameLastFirst }}</option>
                            </b-select>
                            <input-help :form="assignForm" field="specialist_id" text=""></input-help>
                        </b-form-group>
                    </b-col>
               </b-row>
            </b-container>
            <div slot="modal-footer">
               <b-btn variant="default" @click="assignModal = false">Close</b-btn>
               <b-btn variant="info" @click="submitAssignment()">Save</b-btn>
            </div>
        </b-modal>
    </b-card>
</template>

<script>
    export default {
        props: {
            'exceptions': {
                default() {
                    return [];
                }
            },
            title: String,
            type : String
        },

        data() {
            return {
                totalRows: 0,
                perPage: 25,
                currentPage: 1,
                sortBy: null,
                sortDesc: false,
                filter: null,
                selectedItem: {},
                start_date: moment().startOf('isoweek').format('MM/DD/YYYY'),
                end_date: moment().startOf('isoweek').add(6, 'days').format('MM/DD/YYYY'),
                admins: [],
                specialistFilter: '',
                fields: [
                    {
                        key: 'date',
                        label: 'Date',
                        sortable: true,
                    },
                    {
                        key: 'title',
                        label: 'Title',
                        sortable: true,
                    },
                    {
                        key: 'specialist_name',
                        label: 'Assigned To',
                        sortable: true,
                    },
                    {
                        key: 'acknowledged_at',
                        label: 'Acknowledged',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        class: 'hidden-print'
                    }
                ],
                items: [],

                assignModal: false,
                assignForm: new Form({
                    exception_id: '',
                    specialist_id: '',
                }),
            }
        },

        mounted() {
            this.loadItems();
            this.fetchAdmins();
        },

        computed: {
            tableData() {
                console.log('computed executed');
                return this.items.map(function(exception) {
                    exception.date = moment.utc(exception.created_at).local().format('L LT');
                    exception.acknowledged_at = (exception.acknowledged_at) ? moment.utc(exception.acknowledged_at).local().format('L LT') : '';
                    exception.specialist_name = exception.specialist ? exception.specialist.nameLastFirst : '-';
                    return exception;
                });
            },
        },

        methods: {

            loadItems(){

                let form = new Form();

                form.submit( 'GET', `/business/exceptions?json=1&start=${this.start_date}&end=${this.end_date}&type=${this.type}&specialist_id=${this.specialistFilter}` )
                    .then( res => {

                        console.log( 'the response: ', res );
                        this.items = res.data;
                        this.totalRows = this.items.length;
                    })
                    .finally( () => console.log( 'done tho' ) );
            },
            submitAssignment() {
                this.assignForm.post(`/business/exceptions/${this.assignForm.exception_id}/update`)
                    .then( ({ data }) => {
                        let index = this.items.findIndex(obj => obj.id == data.data.id);
                        // console.log(index);
                        // console.log(data.data);
                        if (index >= 0) {
                            this.items.splice(index, 1, data.data);
                        }

                        this.assignModal = false;
                    })
                    .catch (e => {
                        this.assignModal = false;
                    });
            },

            assign(exception) {
                this.assignForm.exception_id = exception.id;
                this.assignForm.specialist_id = exception.specialist_id;
                this.assignModal = true;
            },

            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            },

            fetchAdmins() {
                axios.get('/business/specialists')
                    .then( ({ data }) => {
                        this.admins = data;
                    })
                    .catch(e => {
                        this.admins = [];
                    })
            },
        }
    }
</script>